import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import dateUtils from 'utils/Date';
import { Text } from 'components/ui';
import CheckoutItemsList from 'components/FrictionlessCheckout/CheckoutItemsList';

const PromiseDateAndItems = ({
    shippingMethod,
    showSplitEDD,
    cutOffDescriptionForSplitEdd,
    isEditView,
    standardOnly,
    showAutoReplenishItems,
    extraItems
}) => {
    const {
        promiseDateCutOffDescription, promiseDateLabel, promiseDate, promiseDateTZ, items
    } = shippingMethod;
    const showCheckoutDateAndTimerFormat = !localeUtils.isFRCanada();
    const cutOffDescriptionText =
        promiseDateCutOffDescription && showCheckoutDateAndTimerFormat
            ? `if you ${promiseDateCutOffDescription.toLowerCase()}`
            : promiseDateCutOffDescription;
    const deliveryDate = dateUtils.getPromiseDateTZ(promiseDateTZ, promiseDate);

    if (showSplitEDD && !items?.length && !extraItems?.length) {
        return null;
    }

    return (
        <>
            <Text
                fontSize={['sm', null, 'base']}
                is='p'
                color='gray'
                marginBottom={isEditView ? 2 : 3}
                pt='2px'
            >
                {deliveryDate && (
                    <Text
                        color='green'
                        fontWeight='bold'
                        children={`${promiseDateLabel} ${deliveryDate} `}
                    />
                )}
                {cutOffDescriptionForSplitEdd && <Text> {cutOffDescriptionForSplitEdd} </Text>}
                {cutOffDescriptionText && showCheckoutDateAndTimerFormat && <Text>{cutOffDescriptionText}</Text>}
            </Text>
            <CheckoutItemsList
                shouldDisplayTitle={false}
                splitEddItems={extraItems ? [...(items ?? []), ...extraItems] : items}
                showSplitEDD={showSplitEDD}
                standardOnly={standardOnly}
                showAutoReplenishItems={showAutoReplenishItems}
            />
        </>
    );
};

export default wrapFunctionalComponent(PromiseDateAndItems, 'PromiseDateAndItems');
